import { MaskLines, Reveal } from "./Reveal";

export const SectionHead = ({ index, eyebrow, lines, sub, align = "left", className = "", testId }) => (
  <div className={`${align === "center" ? "mx-auto text-center" : ""} max-w-3xl ${className}`} data-testid={testId}>
    <Reveal className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
      {index && <span className="font-mono text-xs text-zinc-400">{index}</span>}
      <span className="h-px w-8 bg-amber-400/70" />
      <span className="eyebrow">{eyebrow}</span>
    </Reveal>
    <MaskLines lines={lines} className="mt-5 text-[1.7rem] leading-[1.12] sm:text-4xl lg:text-5xl font-semibold uppercase text-white" lineClass="metal-text" />
    {sub && (
      <Reveal delay={0.15} as="p" className="mt-6 text-base md:text-lg leading-relaxed text-zinc-300">
        {sub}
      </Reveal>
    )}
  </div>
);
